
<template>
  <div class="container">
  
    <div class="row">
                <div class="col-md-6">

                  <div class="card mb-4">
                    <h5 class="card-header">تحديث الملف الشخصي</h5>
                    <!-- Account -->
                    <div class="card-body">
                      <div class="d-flex align-items-start align-items-sm-center gap-4">
                        
                        <img  v-if="imageUrl" :src="imageUrl" class="d-block rounded" height="100" width="100"/>

                        <img v-else :src="`https://furncn.com/back-end/public/profile/${getPicture}`" alt="user-avatar" class="d-block rounded" height="100" width="100" id="uploadedAvatar">
                        
                        <div class="button-wrapper">
                          <label for="upload" class="btn btn-primary me-2 mb-4" tabindex="0">
                            <span class="d-none d-sm-block">صورة الملف الشخصي</span>
                            <i class="bx bx-upload d-block d-sm-none"></i>
                            <input type="file" id="upload" class="account-file-input" hidden="" @change="uploadPicture" accept="image/png, image/jpeg">
                          </label>
  

                          <p class="text-muted mb-0">Allowed JPG, GIF or PNG. Max size of 800K</p>
                        </div>
                      </div>
                    </div>
                    <hr class="my-0">
                    <div class="card-body">
                      <input type="hidden" v-model="user_id">

                      <form id="formAccountSettings" method="POST" @submit.prevent="" @submit="update()">
                        <div class="row">
                          <div class="mb-3 col-md-12">
                            <label for="firstName" class="form-label">اسم المستخدم</label>
                            <input  class="form-control" 
                                    type="text" 
                                    required
                                    v-model="getUsername" 
                                    autofocus=""
                            />
                          </div>

                          <div class="mb-3 col-md-12">
                            <label for="email" class="form-label">البريد الالكتروني</label>
                            <input  class="form-control" 
                                    type="email" 
                                    required
                                    v-model="getEmail" 
                                    placeholder="john.doe@example.com"
                            />
                          </div>

                          <div class="mb-3 col-md-12">
                            <label for="email" class="form-label">رقم الهاتف</label>
                            <input  class="form-control" 
                                    type="number" 
                                    required
                                    v-model="getPhone" 
                                    placeholder="054789006"
                            />
                          </div>

                          <div class="mb-3 col-md-12">
                            <label for="email" class="form-label">كلمة المرور</label>
                            <input  class="form-control" 
                                    type="text" 
                                    required
                                    v-model="getPassword" 
                                    placeholder=".........."
                            />
                          </div>

                        </div>
                        <div class="mt-2">
                          <button type="submit" class="btn btn-primary me-2">تحديث البيانات</button>
                        </div>
                      </form>
                    </div>
                    <!-- /Account -->
                  </div>


                </div>
              </div>

  </div> <!-- container -->   
</template>


<script>
import axios from 'axios'

 export default {
  name: "Member",

  data() {
    return {
      getUsername: null,
      getEmail: null,
      getPhone: null,
      getPassword: null,
      user_id : null,
      getPicture: null,
      imageUrl: null,
      picture: null,
      pictureName: null,
    }
  },



  mounted () {
      window.document.title = " الملف الشخصي ";
      if (!localStorage.getItem("status_auth")) {
          window.location.href = '/';
      }
      this.user_id = localStorage.getItem("user_id");
      this.getData();
  }, // mounted

  methods : {

    uploadPicture(e){
      this.picture = e.target.files[0];
      this.imageUrl = URL.createObjectURL(e.target.files[0])
      this.getPicture = e.target.files[0].name;
    },

    async getData(){
      const response = await  axios.get(`profile`);
          this.getUsername  = response.data.name,
          this.getEmail     = response.data.email,
          this.getPhone     = response.data.phone,
          this.getAddress   = response.data.address,
          this.getPassword  = response.data.text_password
          this.getPicture   = response.data.picture
    },





    async update () {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      const formData = new FormData();
      formData.append("id", localStorage.getItem("user_id"));
      formData.append("name", this.getUsername);
      formData.append("email", this.getEmail);
      formData.append("phone", this.getPhone);
      formData.append("city", this.getCity);
      formData.append("address", this.getAddress);
      formData.append("password", this.getPassword);
      formData.append("picture", this.picture);
      formData.append("picture_name", this.pictureName);

      const response = await axios.post(`update.my.acount`, formData);
      this.getPicture = response.data.name;
      Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'رسالة تاكيــــد',
          text: " تم تحديث البيانات بنجاح :)",
          showConfirmButton: false,
          timer: 2000
      })

    },









 }
}
</script>
   